// material
import { Grid, Box } from '@material-ui/core'

export default function Loading() {
    return (
        <>
            <Grid item xs={12}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 300,
                        my: { xs: 0, sm: 0 }
                    }}
                >
                    <Box
                        sx={{
                            width: 60,
                            height: 60,
                            border: '4px solid #f3f3f3',
                            borderTop: '4px solid #1976d2',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                            '@keyframes spin': {
                                '0%': { transform: 'rotate(0deg)' },
                                '100%': { transform: 'rotate(360deg)' }
                            }
                        }}
                    />
                </Box>
            </Grid>
        </>
    )
}

